var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWindowsLogo = function SvgIconWindowsLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 3.75a1 1 0 0 0-1.179-.984L12.946 4.06a1 1 0 0 0-.821.984v5.081a1 1 0 0 0 1 1h7.125a1 1 0 0 0 1-1zm-7.125 5.375V5.879l5.125-.931v4.177zM10.375 5.728a1 1 0 0 0-1.179-.984L3.571 5.766a1 1 0 0 0-.821.984v3.375a1 1 0 0 0 1 1h5.625a1 1 0 0 0 1-1zM4.75 9.125v-1.54l3.625-.659v2.199zM2.75 13.875a1 1 0 0 1 1-1h5.625a1 1 0 0 1 1 1v4.397a1 1 0 0 1-1.179.984l-5.625-1.022a1 1 0 0 1-.821-.984zm2 1v1.54l3.625.659v-2.199zM13.125 12.875a1 1 0 0 0-1 1v5.081a1 1 0 0 0 .821.984l7.125 1.294a1 1 0 0 0 1.179-.984v-6.375a1 1 0 0 0-1-1zm1 5.247v-3.247h5.125v4.177z"
  }))));
};
export default SvgIconWindowsLogo;